module.exports = __webpack_public_path__ + "static/img/1006_small.e74f1c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1006_small.png
// module id = /Tms
// module chunks = 1